/* istanbul ignore file */
import useLeaveService from 'domain/people/leave/shared/leaveService';
import LeaveForm from 'domain/people/leave/createupdate/LeaveForm';
import useLeavesErrorMap from 'domain/people/leave/createupdate/errorHandlers';
import LeaveNotStrictRulesHandler from '../LeaveNotStictRulesHandler';
import { OneStopPageLayout } from 'domain/shared/oneStop';
import { CreateForm } from 'framework/form';
import { LeaveDto } from 'domain/shared/leave';
import { DATE_FORMAT, useDateTimeService } from 'framework/utils';

type OneStopLeaveProps = {
  openModal: (message: string) => void;
};

const OneStopLeave = ({ openModal }: OneStopLeaveProps) => {
  const { createEmployeeLeave, getOneStopValidationSchema } = useLeaveService();
  const { formatDateWithTimezone } = useDateTimeService();
  const errorsMap = useLeavesErrorMap();

  return (
    <CreateForm
      submitFormFunc={createEmployeeLeave}
      afterSubmit={{
        execute: (response: LeaveDto) => {
          openModal(
            `<p>Your Leave request (ID is ${response.id}) was successfully created at ${formatDateWithTimezone(response.createdAt, DATE_FORMAT.FULL)}</p>`,
          );
        },
      }}
      getValidationSchemaFunc={getOneStopValidationSchema}
      errorsMap={errorsMap}
    >
      <LeaveNotStrictRulesHandler errorMap={errorsMap} />
      <OneStopPageLayout>
        <LeaveForm isOneStop />
      </OneStopPageLayout>
    </CreateForm>
  );
};

export default OneStopLeave;
